<template>
  <div>
    <div class="text-nowrap">
      <b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{shipping.id | uuid }}</b-link>
      <a href="#" @click.prevent="copyToClipboard(shipping.id)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </div>
    <message-threads-icon :shipping="shipping" />
  </div>
</template>

<script>
import MessageThreadsIcon from '@/components/Shippings/MessageThreadsIcon'

export default {
  name: 'ShippingsListItemId',
  components: {
    MessageThreadsIcon
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
